var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"toast"},on:{"enter":_vm.onEnter}},[(_vm.showToast)?_c('div',{class:_vm.toastClasses},[_c('p',[_vm._v(_vm._s(_vm.message))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }